<template>
  <div class="flex flex-col items-center" >

    <div :class="computedBackgroundClass" :style="cssVars" class="p-2 h-full md:max-w-7xl w-full"
    >
      <div :class="`border-4 rounded-sm border-white h-full w-full`">
        <div
            class="flex flex-col md:flex-row items-center h-full w-full overflow-hidden transition-colors duration-300"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import router from "@/router/index.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();

const props = defineProps({
  colors: {type: Object, required: true},
  backgroundVariant: {type: Number, default: 1},
  lessTranslucent: {type: Boolean, default: false}
});

// Compute CSS variables dynamically
const cssVars = computed(() => ({
  "--bg-light-variant-1": props.colors.whitest,
  "--bg-light-variant-2": props.colors.lightest,
  "--bg-light-variant-3": props.colors.light,
  "--bg-dark-variant-1": props.colors.dark,
  "--bg-dark-variant-2": props.colors.darkest,
  "--link-color": props.colors.accent,
  "--link-hover-color": props.colors.accentDark
}));

// Compute background class dynamically using Tailwind's dark mode
const computedBackgroundClass = computed(() => {
      if (props.lessTranslucent) {
        return props.backgroundVariant === 1
            ? "bg-[var(--bg-light-variant-1)]/70 backdrop-blur-3xl  shadow-[var(--bg-dark-variant-2)]/70 shadow-lg rounded-sm  dark2:bg-[var(--bg-dark-variant-2)]"
            : "bg-[var(--bg-light-variant-3)]/70 backdrop-blur-3xl  shadow-[var(--bg-dark-variant-2)]/70 shadow-lg rounded-sm  dark2:bg-[var(--bg-dark-variant-2)]"

      } else {
        return props.backgroundVariant === 1
            ? "bg-[var(--bg-light-variant-1)]/20 backdrop-blur-3xl  shadow-[var(--bg-dark-variant-2)]/30 shadow-lg rounded-sm  dark2:bg-[var(--bg-dark-variant-2)]"
            : "bg-[var(--bg-light-variant-3)]/20 backdrop-blur-3xl  shadow-[var(--bg-dark-variant-2)]/30 shadow-lg rounded-sm  dark2:bg-[var(--bg-dark-variant-2)]"

      }
    }
    // : "bg-linear-65  from-[var(--bg-light-variant-2)] to-[var(--bg-light-variant-3)]/20 -my-12   md:-my-10 dark2:bg-black"
);

// Navigate using Vue Router
const navigate = () => {
  if (props.link) {
    router.push(back(props.link));
  }
};
</script>

<style scoped>

.link-style:hover .arrow-icon {
  transform: translateX(3px);
}

.dark .glass-section {
  background: rgba(0, 0, 0, 0.2);
}


</style>
